#import "../../../core/subdomains/graphql/fragments/subdomain-fragment.graphql"

fragment SchedulerPageConfigFragment on PageConfig {
    id
    useAvatar
    useCompanyLogo
    userSlug
    fromDomain {
        ...SubdomainFragment
    }
    defaultUserSlug
    defaultFromDomain {
        ...SubdomainFragment
    }
    embedSnippet
}
